import React, { memo } from 'react';
import { View } from 'react-native';
import ThemeProvider from '@voltmoney/theme';
import { ColorTokens, BorderRadiusTokens, SizeTypeTokens, StackAlignType, StackType, } from '@voltmoney/schema';
import Stack from '../stack/Stack';
import Space from '../space/Space';
const ProgressIndicatorBase = ({ size = 1, activeIndex = 0, color = ColorTokens.System_Happy, borderRadius = BorderRadiusTokens.BR4, height = SizeTypeTokens.MD, fillPercentage, bgColor, }) => {
    const theme = ThemeProvider.getTheme();
    const colorMapping = theme.colors;
    const borderRadiusValue = theme.borderRadius[borderRadius];
    const heightValue = theme.space[height];
    const renderIndicator = (_, index) => {
        return (React.createElement(View, { style: {
                width: '100%',
                backgroundColor: bgColor
                    ? colorMapping[bgColor]
                    : colorMapping[color],
            } },
            React.createElement(View, { style: {
                    width: fillPercentage,
                    // width: 100,
                    height: heightValue,
                    borderRadius: borderRadiusValue,
                    backgroundColor: colorMapping[color],
                    opacity: index <= activeIndex ? 1 : 0.3,
                } }),
            React.createElement(Space, { size: index + 1 == size
                    ? SizeTypeTokens.NONE
                    : SizeTypeTokens.SM })));
    };
    return (React.createElement(Stack, { type: StackType.row, alignY: StackAlignType.center, alignX: StackAlignType.spaceBetween }, Array.from({ length: size }).map(renderIndicator)));
};
export default memo(ProgressIndicatorBase);
export { ProgressIndicatorBase };
